import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { retrieveToken } from "../../../utils/storage";
import { endpoint } from "../../../utils/constants/endpoint";

export const assistenteSmartApi = createApi({
  reducerPath: "adminChatConversation",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  tagTypes: ["chat-admin"],
  endpoints: (builder) => ({
    getAllChatConversation: builder.query({
      query: ({
        page: { startRow, endRow },
        filter = {
          userId: "",
          adminId: "",
          practiceId: "",
          status: "",
        },
      }) => ({
        url: `admin/Chat/conversation?userId=${filter.userId}&adminId=${filter.adminId}&practiceId=${filter.practiceId}&status=${filter.status}`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: {
          startRow,
          endRow,
          sort: [
            {
              colId: "updateAt",
              sortDirection: "desc",
              sortIndex: 0,
            },
          ],
        },
      }),
      providesTags: ["chat-admin"],
    }),

    getChatConversationById: builder.query({
      query: (id) => ({
        url: "/admin/Chat/" + id,
        method: "GET",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
      }),
    }),

    getChatCategories: builder.query({
      query: () => ({
        url: "admin/enums/chatcategories",
        method: "GET",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
      }),
    }),
    doCreateChat: builder.mutation({
      query: (body) => ({
        url: "/admin/Chat/conversation/create",
        method: "POST",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: body,
      }),
      invalidatesTags: ["chat-admin"],
    }),

    doSendingChat: builder.mutation({
      query: (body) => ({
        url: endpoint.ADMIN_CHAT.CHAT + body.id,
        method: "POST",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: body,
      }),
      invalidatesTags: ["chat-admin"],
    }),

    doDeleteChat: builder.mutation({
      query: (body) => ({
        url: endpoint.ADMIN_CHAT.CHAT + body.chatId,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: body,
      }),
      invalidatesTags: ["chat-admin"],
    }),

    doDeleteConversation: builder.mutation({
      query: (body) => ({
        url: "/admin/Chat/conversation/" + body.conversationId,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: body,
      }),
      invalidatesTags: ["chat-admin"],
    }),

    doDeleteMessageChat: builder.mutation({
      query: (body) => ({
        url: "/admin/Chat/" + body.conversationId + "/" + body.messageId,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: body,
      }),
    }),

    doEditMessageChat: builder.mutation({
      query: (body) => ({
        url:
          endpoint.ADMIN_CHAT.CHAT + body.conversationId + "/" + body.messageId,
        method: "PUT",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: body,
      }),
    }),

    doSetreadConversation: builder.mutation({
      query: (body) => ({
        url:
          endpoint.ADMIN_CHAT.NEW_CHAT + "/" + body.conversationId + "/setread",
        method: "POST",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: body,
      }),
      invalidatesTags: ["chat-admin"],
    }),

    doArchiviedConversation: builder.mutation({
      query: (body) => ({
        url:
          endpoint.ADMIN_CHAT.NEW_CHAT + "/" + body.conversationId + "/archive",
        method: "POST",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: body,
      }),
      invalidatesTags: ["chat-admin"],
    }),
  }),
});

export const {
  useGetAllChatConversationQuery,
  useGetChatConversationByIdQuery,
  useGetChatCategoriesQuery,
  useDoCreateChatMutation,
  useDoSendingChatMutation,
  useDoDeleteChatMutation,
  useDoDeleteConversationMutation,
  useDoDeleteMessageChatMutation,
  useDoEditMessageChatMutation,
  useDoSetreadConversationMutation,
  useDoArchiviedConversationMutation,
} = assistenteSmartApi;
